import _util from '../utils';
import apiUrl from '../utils/api-url';
const axios = require('axios')
const newsApi = {
  getNewList(page, resolve, reject) {
    const current_lang = _util.getCurrentLang()
    let url = apiUrl.url + '/api/' + current_lang + '/news'
    if(page){
      url += '?page=' + page
    }

    axios.get(url)
    .then(function(response){
      resolve(response.data)
    })
    .catch(function(error){
      reject(error)
    })
  },

  getImageNewsList(resolve, reject){
    const current_lang = _util.getCurrentLang()
    let url = apiUrl.url + '/api/' + current_lang + '/news?page=1&per_page=100'
    axios.get(url)
    .then(function(response){
      resolve(response.data)
    })
    .catch(function(error){
      reject(error)
    })
  },

  getNewDetail(id, resolve, reject) {
    const current_lang = _util.getCurrentLang()
    var url = apiUrl.url + '/api/' + current_lang + '/news/' + id
    axios.get(url)
    .then(function(response){
      resolve(response.data)
    })
    .catch(function(error){
      reject(error)
    })
  }
}

export default newsApi



// WEBPACK FOOTER //
// ./src/api/news-api.js